<template>
  <div class="c-navigator navigator">
    <router-link class="navigator__link" to="/">
      <svg class="navigator__logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 7.5" ref="logo">
        <polygon points="6.3,0.1 6.3,0.2 3.6,4 0.9,0.1 0.9,0.1 0.9,0.1 0,0.1 0,7.2 0.9,7.2 0.9,7.2 0.9,1.5 3.6,5.4 6.3,1.6 6.3,7.2
          7.2,7.2 7.2,0.1 "/>
        <path d="M18,7.4c-2,0-3.7-1.7-3.7-3.7S16,0,18,0s3.7,1.7,3.7,3.7S20,7.4,18,7.4z M18,0.8c-1.6,0-2.9,1.3-2.9,2.9
          c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S19.6,0.8,18,0.8z"/>
        <path d="M31.9,7.4c-2,0-3.7-1.7-3.7-3.7S29.9,0,31.9,0s3.7,1.7,3.7,3.7S33.9,7.4,31.9,7.4z M31.9,0.8c-1.6,0-2.9,1.3-2.9,2.9
          c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S33.5,0.8,31.9,0.8z"/>
        <path d="M42.5,0.2h0.9l3.4,4.4C47.3,5.2,47.7,6,47.7,6V0.2h0.9v7.1h-0.9L44.4,3c-0.5-0.7-1-1.5-1-1.5v5.7h-0.9
          C42.5,7.2,42.5,0.2,42.5,0.2z"/>
        <path d="M55.8,5.7c0.6,0.6,1.3,1,2.4,1c0.9,0,1.9-0.4,1.9-1.3c0-0.8-0.9-1.1-1.8-1.3c-1.3-0.3-2.6-0.7-2.6-2c0-1.2,1.2-1.9,2.5-1.9
          c1,0,1.7,0.3,2.4,0.8l-0.4,0.7c-0.6-0.4-1.3-0.7-2-0.7c-0.6,0-1.6,0.3-1.6,1.1s0.8,1,1.8,1.2C59.7,3.6,61,4,61,5.4
          c0,1.4-1.4,2.1-2.8,2.1c-1.3,0-2.2-0.5-2.8-1.1C55.4,6.4,55.8,5.7,55.8,5.7z"/>
        <path d="M67.8,0.2h0.9v2.9h4.1V0.2h0.9v7.1h-0.9V3.9h-4.1v3.4h-0.9V0.2z"/>
        <path d="M84.3,7.4c-2,0-3.7-1.7-3.7-3.7S82.3,0,84.3,0S88,1.7,88,3.7S86.3,7.4,84.3,7.4z M84.3,0.8c-1.6,0-2.9,1.3-2.9,2.9
          c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9C87.2,2.1,85.9,0.8,84.3,0.8z"/>
        <polygon points="100,0.2 97.3,0.2 96.5,0.2 93.8,0.2 93.8,1 96.5,1 96.5,7.3 97.3,7.3 97.3,1 100,1 "/>
      </svg>
    </router-link>
    <NavigatorBurger
      ref="burger"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { TweenMax, Power4 } from 'gsap/TweenMax';
import NavigatorBurger from '@/components/NavigatorBurger.vue';
import NavigatorMenu from '@/components/NavigatorMenu.vue';

export default {
  name: 'AppBurger',
  components: {
    NavigatorBurger,
    NavigatorMenu,
  },
  computed: {
    ...mapState(['menuOpen']),
  },
  mounted() {
    this.init();
  },
  methods: {
    toggleMenu() {
      this.$store.commit('TOGGLE_MENU');
    },
    init() {
      const logoLetters = Array.from(this.$refs.logo.childNodes);
      TweenMax.set(logoLetters, { y: 10 });
      TweenMax.set(this.$refs.burger.$el, {
        webkitClipPath: 'inset(0% 0.01% 0.02% 100%)',
        clipPath: 'inset(0% 0.01% 0.02% 100%)',
      });
    },
    enter() {
      const logoLetters = Array.from(this.$refs.logo.childNodes);
      TweenMax.staggerTo(logoLetters, 0.8, {
        y: 0,
        ease: Power4.easeOut,
        delay: 0.5,
      }, 0.08);
      TweenMax.to(this.$refs.burger.$el, 1.3, {
        webkitClipPath: 'inset(0% 0.01% 0.02% 0.03%)',
        clipPath: 'inset(0% 0.01% 0.02% 0.03%)',
        ease: Power4.easeOut,
        delay: 0.5,
      });
    },
  },
};
</script>

<style lang="scss" scoped>



.navigator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  pointer-events: none;
  z-index: z-index(header);

  &__link {
    position: absolute;
    top: 15px;
    left: 20px;
    width: 150px;
    height: auto;

    pointer-events: all;

    @include mq(ipadL) {
      top: 44px;
      left: 50px;
    }

    svg path,
    svg polygon {
      display: inline-block;
      fill: white;
    }
  }
}
</style>
